export default {
	国家: 'Country',
	前缀: 'Prefix',
}
